export const isMediaServerUrl = url => url.includes('media://')
